export enum EnabledRedactions {
  WithoutRedactions = 'WithoutRedactions',
  WithRedactions = 'WithRedactions',
}
